<h1 class="font-grotesk-h5 headline">
  <ng-content />
</h1>
